export const INVALID_UUID_ERROR_MESSAGE = 'uuid is invalid'
export const INVALID_UUID_STATUS = 400
export const NOT_FOUND_STATUS = 404
